/**
 * Jedini izvor istine za podatke o firmi.
 *
 * Isti podaci su ranije bili hardkodovani na tri mjesta (pdf-shell,
 * placeholders, footer-config). Adresa iz schema.org `PostalAddress` mora se
 * poklapati s onom na Google Business profilu, u footeru i na PDF ugovorima,
 * pa četiri nezavisne kopije nisu opcija.
 */
export const ORGANIZATION = {
  name: "Psihotron",
  legalName: "Agencija za savjetovanje Psihotron",
  registrationNumber: "16-17-331/21",
  idNumber: "4303509360003",
  vatNumber: "303509360003",
  streetAddress: "Dajanli Ibrahim bega br. 14",
  postalCode: "71000",
  city: "Sarajevo",
  countryCode: "BA",
  countryName: "Bosna i Hercegovina",
  phone: "+387 60 329 7007",
  phoneE164: "+387603297007",
  email: "info@psihotron.ba",
  director: "Sandra Zaimović",
  directorTitle: "Geštalt psihoterapeutkinja",
  foundingYear: "2021",
  socials: [
    "https://www.instagram.com/psihotron.ba/",
    "https://www.facebook.com/profile.php?id=100069887408882",
  ],
} as const;

/** Ulica, poštanski broj i grad u jednom redu, kako stoji na PDF dokumentima. */
export function fullAddress(): string {
  return `${ORGANIZATION.streetAddress}, ${ORGANIZATION.postalCode} ${ORGANIZATION.city}`;
}
